(() => {
  'use strict';
  if (window.hgEventsInitialized) return;
  window.hgEventsInitialized = true;
  // Ticket links navigate directly; checkout must not depend on an embedded modal.
  const refresh = (root) => {
    const cards = [...root.querySelectorAll('[data-hg-event]')];
    cards.forEach(card => {
      const start = Date.parse(card.dataset.start), end = Date.parse(card.dataset.end);
      card.hidden = !Number.isFinite(start) || !Number.isFinite(end) || end <= start || end <= Date.now();
    });
    root.querySelector('[data-hg-events-empty]').hidden = cards.some(card => !card.hidden);
  };
  const init = () => document.querySelectorAll('[data-hg-events]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    refresh(root);

  });
  init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) document.querySelectorAll('[data-hg-events]').forEach(refresh);
  });
  setInterval(() => document.querySelectorAll('[data-hg-events]').forEach(refresh), 60000);
})();
